import { getResourceFromCms } from '@namespace/helpers';
import { GamesProvidersType, IGames, PlatformType } from '../../../types';

interface IGetGamesFeedParams {
  feedNames: string;
  platform: PlatformType;
  userSegments?: string[];
}

interface IContent {
  games: string[];
  name: string;
  instantGames?: string[];
  settings?: {
    logo: string;
    logoActive: string;
    nameTranslationKey: string;
  };
}

export type FeedContentType = Record<string, IContent>;

interface IFeed {
  categories: string[];
  providers: string[];
  feedName: string;
  content: FeedContentType;
}

export interface IGetGamesFeedResponse {
  feeds: IFeed[];
  games: IGames;
  providers: GamesProvidersType;
}

export const getGamesFeed = ({
  feedNames,
  platform,
  userSegments = []
}: IGetGamesFeedParams) =>
  getResourceFromCms<IGetGamesFeedResponse>(
    `/gamesFeedsBatch?feedNames[]=${feedNames}&platform=${platform}&${userSegments
      .map((userSegment) => `userSegments[]=${userSegment}&`)
      .join('')
      .slice(0, -1)}`
  );
